/* AUTAVEX — фото комплектацій та аксесуарів для ворсових */
window.AV_VORS_PICS={
  logo:'IMG-3039.png?v=1786094741',
  heel:'FullSizeRender_b87c0820-b6b0-44fe-8510-f3da419f39ff.jpg?v=1786092970',
  gift:'IMG-3753.png?v=1786443390',
  front:'IMG-3770.png?v=1786446944',
  full:'IMG-3764.png?v=1786446687',
  bus:'IMG-3770.png?v=1786446944',
  mini:'IMG-3764.png?v=1786446687',
  trunk:'IMG-3767.png?v=1786446687'
};
